import React from 'react';

export function setRef(ref: React.Ref<any>, value: any) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    //@ts-expect-error
    ref.current = value;
  }
}
// TODO: Figure out the typing
export function useForkRef(refA: any, refB: any) {
  return React.useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return (refValue: any) => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}
